<template>
  <body>
    <!-- 한국어 -->
    <template v-if="isKorean">
      <h3 class="title">개인정보처리방침</h3>

      <div class="wrapper-paragraph">
        <p class="accent">시행일: 2025년 12월 22일</p>
        <p>
          SconAI(이하 "회사")는 이용자의 개인정보를 소중히 생각하며,
          「개인정보 보호법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등
          관련 법령을 준수하고 있습니다.
        </p>
        <p>
          본 개인정보처리방침은 회사가 제공하는 SconChat 서비스(이하 "서비스")와
          관련하여 회사가 이용자의 개인정보를 어떠한 목적으로, 어떠한 방식으로
          수집·이용하고 있으며, 개인정보보호를 위해 어떠한 조치를 취하고 있는지
          알려드립니다.
        </p>
      </div>

      <!-- 제1조 -->
      <h4 class="accent section-title">제1조 (총칙)</h4>
      <div class="wrapper-paragraph">
        <p>
          개인정보라 함은 살아있는 개인에 관한 정보로서 성명, 주민등록번호, 영상 등을
          통해 개인을 알아볼 수 있는 정보를 말합니다.
        </p>
        <p>
          회사는 개인정보 보호를 위해 본 개인정보처리방침을 제정하고 이를 준수합니다.
        </p>
        <p>
          본 방침은 서비스 초기 화면 또는 연결 화면에 공개됩니다.
        </p>
        <p>
          개인정보처리방침이 변경되는 경우 웹사이트를 통해 공지합니다.
        </p>
      </div>

      <!-- 제2조 -->
      <h4 class="accent section-title">제2조 (개인정보의 수집 및 이용 목적)</h4>
      <div class="wrapper-paragraph">
        <p>
          회사는 다음의 목적을 위하여 개인정보를 처리하며, 목적 외 용도로 이용되지
          않습니다.
        </p>

        <p class="accent">· 서비스 제공 및 계약 이행</p>
        <p>서비스 제공, 결제 및 정산, 본인 확인</p>

        <p class="accent">· 회원 관리</p>
        <p>
          회원 가입 및 관리, 본인 확인, 부정 이용 방지, 민원 처리 및 고지사항 전달
        </p>

        <p class="accent">· 서비스 개선</p>
        <p>
          서비스 이용 분석, 통계 산출, 맞춤형 서비스 제공 및 신규 서비스 개발
        </p>

        <p class="accent">· 마케팅 및 광고</p>
        <p>
          이용자의 별도 동의 시 이벤트 안내 및 광고성 정보 제공
        </p>

        <p class="accent">· 보안 및 안정성 확보</p>
        <p>
          불법·부정 이용 방지 및 서비스 안정성 확보
        </p>
      </div>

      <!-- 제3조 -->
      <h4 class="accent section-title">제3조 (수집 항목 및 수집 방법)</h4>
      <div class="wrapper-paragraph">
        <p>
          회사는 서비스 제공을 위해 최소한의 개인정보만을 수집합니다.
        </p>

        <p class="accent">· 회원 가입 시</p>
        <p>
          Google/Meta 계정 정보, 이메일, 고유 식별자, IP 주소
        </p>

        <p class="accent">· 구독 서비스 이용 시</p>
        <p>
          성명, 연락처, 결제 정보
        </p>

        <p class="accent">· 서비스 이용 기록</p>
        <p>
          접속 IP, 브라우저 정보, 이용 기록, 쿠키
        </p>

        <p class="accent">· 통역·번역 데이터</p>
        <p>
          입력·출력된 음성 및 텍스트 데이터 (목적 달성 후 즉시 삭제)
        </p>

        <p class="accent">· 고객 문의</p>
        <p>
          문의 내용 및 처리 이력
        </p>
      </div>

      <!-- 제4조 -->
      <h4 class="accent section-title">제4조 (보유 및 이용 기간)</h4>
      <div class="wrapper-paragraph">
        <p>
          개인정보는 법령 또는 동의받은 기간 동안 보유하며, 목적 달성 시 파기합니다.
        </p>

        <p class="accent">· 회원 정보</p>
        <p>회원 탈퇴 또는 목적 달성 시까지</p>

        <p class="accent">· 결제 및 거래 기록</p>
        <p>최대 5년 보관</p>

        <p class="accent">· 접속 기록</p>
        <p>최대 3개월 보관</p>
      </div>

      <!-- 제5조 -->
      <h4 class="accent section-title">제5조 (제3자 제공)</h4>
      <div class="wrapper-paragraph">
        <p>
          회사는 원칙적으로 개인정보를 외부에 제공하지 않습니다.
        </p>
        <p>
          단, 이용자 동의 또는 법령에 따른 경우는 예외로 합니다.
        </p>
      </div>

      <!-- 제6조 -->
      <h4 class="accent section-title">제6조 (개인정보 처리 위탁)</h4>
      <div class="wrapper-paragraph">
        <p>· 결제 처리: 토스페이먼츠</p>
        <p>· 클라우드 운영: AWS, Azure, GCP</p>
        <p>· 고객 지원: 문의 응대 및 처리</p>
      </div>

      <!-- 제7조 -->
      <h4 class="accent section-title">제7조 (파기 절차 및 방법)</h4>
      <div class="wrapper-paragraph">
        <p>
          개인정보는 목적 달성 후 지체 없이 파기됩니다.
        </p>
        <p>· 전자 파일: 복구 불가한 방식으로 삭제</p>
        <p>· 종이 문서: 분쇄 또는 소각</p>
      </div>

      <!-- 제8조 -->
      <h4 class="accent section-title">제8조 (이용자의 권리)</h4>
      <div class="wrapper-paragraph">
        <p>
          이용자는 개인정보 열람, 정정, 삭제, 처리 정지를 요청할 수 있습니다.
        </p>
      </div>

      <!-- 제9조 -->
      <h4 class="accent section-title">제9조 (쿠키)</h4>
      <div class="wrapper-paragraph">
        <p>
          회사는 맞춤형 서비스 제공을 위해 쿠키를 사용합니다.
        </p>
        <p>
          이용자는 브라우저 설정을 통해 쿠키 저장을 거부할 수 있습니다.
        </p>
      </div>

      <!-- 제10조 -->
      <h4 class="accent section-title">제10조 (개인정보 보호책임자)</h4>
      <div class="wrapper-paragraph">
        <p>개인정보 보호책임자: Applied AI · 박장원</p>
        <p>연락처: jwpark@sconai.com</p>
      </div>

      <!-- 제11조 -->
      <h4 class="accent section-title">제11조 (안전성 확보 조치)</h4>
      <div class="wrapper-paragraph">
        <p>· 관리적 조치: 내부관리계획 및 교육</p>
        <p>· 기술적 조치: 접근 통제, 암호화</p>
        <p>· 물리적 조치: 출입 통제</p>
      </div>

      <!-- 제12조 -->
      <h4 class="accent section-title">제12조 (고지)</h4>
      <div class="wrapper-paragraph">
        <p>
          본 방침은 시행일로부터 적용되며, 변경 시 사전 공지합니다.
        </p>
        <p>
          시행일: 2025년 12월 22일
        </p>
      </div>
    </template>

    <!-- English (default) -->
    <template v-else>
      <h3 class="title">Privacy Policy</h3>

      <div class="wrapper-paragraph">
        <p class="accent">Updated 12 November 2025</p>
        <p>
          This Privacy Policy ("Policy") describes how SconAI Inc. and its affiliates ("SconAI," "we," "us," or "our")
          collect, use, store, and protect Personal Data (as defined below) of individuals who access or use our website
          or services (collectively, the "Services") or otherwise interact with us.
        </p>
        <p>
          This Policy also explains the rights and choices available to you regarding your Personal Data, including how
          you can access, correct, or update certain information about yourself.
        </p>
        <p>
          Where our processing relies on your consent, and to the extent permitted by applicable law, your continued use
          of the Services or interaction with SconAI constitutes your consent to the collection and use of your Personal
          Data as outlined in this Policy.
        </p>

        <p class="accent">(a) Definitions</p>
        <p>
          For purposes of this Policy, "Personal Data" means any information that identifies or can reasonably be used
          to identify an individual, such as a name, mailing address, telephone number, or email address.
        </p>
        <p>In some jurisdictions, this information may also be referred to as "Personal Information."</p>

        <p class="accent">(b) Scope</p>
        <p>
          This Policy applies only to situations where SconAI acts as the data controller—that is, when we determine
          the purposes and means of processing Personal Data, including when we provide the SconChat Services directly
          to individual users.
        </p>
        <p>This Policy does not apply when we process Personal Data on behalf of business or enterprise customers.</p>
        <p>
          In those cases, SconAI functions as a data processor or service provider, and our handling of Personal Data
          is governed by the data processing agreement established with the respective customer.
        </p>
      </div>

      <!-- Section 2 -->
      <h4 class="accent section-title">2. Categories of Personal Data We Collect</h4>
      <div class="wrapper-paragraph">
        <p class="accent">(a) Personal Data You Provide to Us</p>

        <p class="accent">Account Information.</p>
        <p>
          When you create an account to use our Services, we may collect basic details such as your name and email
          address, along with information necessary to manage your account and authentication.
        </p>

        <p class="accent">Services Input & Output.</p>
        <p>
          We process the data you provide through your use of the Services ("Input"), which may include text, audio,
          or other content, as well as the data generated in response ("Output").
        </p>
        <p>Both Input and Output may include Personal Data, depending on what you submit through the Services.</p>

        <p class="accent">Audio Recordings and Voice Data.</p>
        <p>
          If you use features that involve your voice, we may collect audio recordings and associated voice data solely
          for the purpose of providing translation or interpretation functionality.
        </p>
        <p>
          Your voice data is used only to reproduce translation audio that reflects your speaking characteristics and
          is not used or analyzed for AI model training, research, or any unrelated purpose.
        </p>

        <p class="accent">Profile Information and User Content.</p>
        <p>
          If you create a profile within the Services, you may choose to provide optional details such as your display
          name, or voice characteristics.
        </p>

        <p class="accent">Feedback and Communications.</p>
        <p>
          When you contact us—for example, to request support, provide feedback, or subscribe to updates—we may collect
          information such as your name, email address, and the content of your message or attachments.
        </p>
        <p>
          We may also track general engagement metrics (e.g., whether an email is opened) to improve our communication
          and service quality.
        </p>

        <p class="accent">Payment Details.</p>
        <p>
          If you purchase a paid subscription or use a paid feature, our payment processor (e.g., Stripe) will collect
          and process your payment information, such as your name, billing details, and payment method.
        </p>
        <p>
          We do not store or have access to your full payment credentials. For more information, please review Stripe's
          Privacy Policy.
        </p>

        <p class="accent">Verification Information.</p>
        <p>
          Where required by law or for account integrity, we may ask for limited verification data—such as your date of
          birth or an identity confirmation document—to ensure lawful use of our Services.
        </p>

        <p class="accent">Other Information You Provide.</p>
        <p>
          We may also collect information you voluntarily share with us, such as when you test early-access
          (alpha/beta) features, participate in user research or events, or interact with SconAI representatives online
          or offline.
        </p>
        <p>Some of these activities may be governed by separate terms or notices.</p>

        <p class="accent">(b) Personal Data We May Collect Automatically</p>

        <p class="accent">Information from Cookies and Similar Technologies.</p>
        <p>
          We and certain third-party partners may gather information using cookies, pixel tags, SDKs, or comparable
          technologies ("Cookies"). These technologies help us understand how our Services are used, remember your
          preferences, and improve performance.
        </p>

        <p class="accent">Location Information.</p>
        <p>
          When you use the Services, we may infer your general geographic location—for example, based on your Internet
          Protocol (IP) address. In some regions, we will request your consent before collecting or inferring this
          information.
        </p>

        <p class="accent">Device Information.</p>
        <p>
          We receive details about the device and software you use to access the Services, such as IP address, browser
          type, operating system version, device model and identifiers, and application versions.
        </p>

        <p class="accent">Usage Information.</p>
        <p>
          We collect information about how you interact with the Services, including the pages or features you access,
          the content you view, the actions you take, the frequency and duration of your visits, and the date and time
          of each session. This information helps us operate, secure, and improve the overall performance and
          reliability of the Services.
        </p>

        <p class="accent">(c) Personal Data We Collect from Third Parties</p>

        <p class="accent">Information from Third Parties.</p>
        <p>
          Where permitted under applicable law, SconAI may collect publicly available information from third-party
          websites or platforms to support the development and improvement of our models and systems.
        </p>
        <p>
          We may also collaborate directly with third parties to obtain information that enables us to enhance the
          performance and accuracy of our Services.
        </p>

        <p class="accent">Third-Party Logins.</p>
        <p>
          If you choose to sign up for or access our Services using a third-party account (for example, Google or
          Meta), we will receive certain Personal Data from that third party, such as your name, email address, and
          profile image.
        </p>

        <p class="accent">Information from Service Providers.</p>
        <p>
          We may receive Personal Data from authorized third-party service providers that are permitted to share such
          information with us. This may include data used for identity verification, background checks, data
          enrichment, or compliance-related reviews such as Know Your Customer (KYC) and Anti-Money Laundering (AML)
          checks.
        </p>
        <p>
          In certain cases, we may need to collect specific Personal Data in order to deliver our Services. If you
          choose not to provide such information, you may be unable to access or use some features of the Services.
        </p>
        <p>
          Where applicable, we will inform you if the provision of Personal Data is required by law or contract, and
          explain any potential consequences of not providing it.
        </p>
      </div>

      <!-- Section 3 -->
      <h4 class="accent section-title">3. Purposes of Processing Personal Data and Legal Basis</h4>
      <div class="wrapper-paragraph">
        <p class="accent">(a) Purpose and Legal Basis</p>
        <p>
          The table below outlines the primary purposes for which SconAI processes your Personal Data when acting as a
          data controller, as well as the corresponding legal bases for such processing.
        </p>
        <p>
          Where we rely on legitimate interests as the legal basis, you have the right to object to such processing as
          described in Section 8 ("Your Rights") of this Policy.
        </p>
        <p>
          If the legal bases listed below are not recognized under the laws of your jurisdiction, we will rely on your
          consent or other lawful grounds available to process your Personal Data.
        </p>
        <p class="small">
          · We process your Personal Data to provide and operate the SconChat Services you request, in accordance with
          our Terms of Service. This processing is necessary for the performance of a contract to which you are a party.
        </p>
        <p class="small">
          · We collect the audio recordings and related voice data you choose to share with us to enable translation,
          interpretation, and other communication features within the SconChat Services. This processing is necessary
          for the performance of a contract to which you are a party.
        </p>
        <p class="small">
          · When you use voice-related features such as translation or interpretation, we may process your voice
          recordings and other Personal Data you provide to accurately reproduce translated or interpreted audio that
          reflects your voice characteristics. This processing is necessary for the performance of a contract to which
          you are a party.
        </p>
        <p class="small">
          · We may process your Personal Data, including voice data, to verify that the audio you provide belongs to
          you, to confirm your consent for voice use where applicable, and to prevent unauthorized or fraudulent
          activity, including misuse of voice data. This processing is necessary for our legitimate interest in
          maintaining the security and integrity of our platform and for the establishment, exercise, or defense of
          legal claims.
        </p>
        <p class="small">
          · With your permission, we may use your Personal Data to personalize your experience when using our Services,
          including offering recommendations or features that may be relevant to you. We have a legitimate interest in
          using your Personal Data for personalization purposes.
        </p>
        <p class="small">
          · We may process your Personal Data to communicate with you, provide updates about the Services, respond to
          inquiries, and offer technical or customer support. Such processing is based on our legitimate interest in
          maintaining user communication and may also be necessary for the performance of a contract with you.
        </p>
        <p class="small">
          · We may process your Personal Data to handle billing and payments related to your use of our Services and to
          maintain payment records. This processing is necessary for the performance of a contract to which you are a
          party.
        </p>
        <p class="small">
          · We process your Personal Data to detect and prevent fraud, misuse, or other illegal activities and to
          ensure the integrity of our Services. This processing is based on our legitimate interest in protecting both
          users and the platform, and may also be required to fulfill contractual or legal obligations.
        </p>
        <p class="small">
          · We may store your Personal Data, including audio data, using secure third-party cloud services as part of
          providing our Services. Such processing is based on our legitimate interest in maintaining service continuity
          and may also be necessary to fulfill our contractual obligations to you.
        </p>
        <p class="small">
          · We may process your Personal Data to ensure the security and stability of our systems, prevent unauthorized
          access, and protect the safety of our platform and users. This processing is based on our legitimate interest
          in ensuring service reliability and security.
        </p>
        <p class="small">
          · We may use your Personal Data to provide technical support, including diagnosing and resolving issues you
          report. This processing is necessary for the performance of a contract to which you are a party.
        </p>
        <p class="small">
          · We may process your Personal Data to understand how our Services are used, identify trends, and improve
          features, functionality, and reliability. This processing is based on our legitimate interest in enhancing
          the Services.
        </p>
        <p class="small">
          · We may process your Personal Data to generate aggregated or de-identified data for analytical and service
          improvement purposes. Such data is used in anonymous form and cannot identify you. This processing is based
          on our legitimate interest in improving service performance.
        </p>
        <p class="small">
          · We may process your Personal Data to address administrative or legal matters related to SconAI, including
          enforcing our Terms of Service, handling disputes, or responding to lawful requests from regulatory or
          governmental authorities. This processing is based on our legitimate interest in fulfilling administrative
          and legal obligations.
        </p>
        <p class="small">
          · We process your Personal Data to comply with legal obligations, including accounting, taxation, or other
          regulatory requirements, and to respond to lawful orders or judicial processes. This processing is required
          to comply with legal obligations.
        </p>
        <p class="small">
          · We do not use customer voice data or Personal Data for AI model training, research, or unrelated
          development. Your data is used strictly to provide translation and interpretation services and to improve
          operational reliability within those services.
        </p>
        <p>
          If we intend to use your Personal Data for any other purpose, we will provide a specific notice at the time
          of collection.
        </p>
        <p>
          We rely on our legitimate interests to process Personal Data only when those interests do not outweigh your
          rights or freedoms. If we process your information based on legitimate interest, you have the right to object
          to such processing at any time.
        </p>

        <p class="accent">(b) Personal Data and SconChat Voice Data</p>
        <p>
          SconAI uses voice data solely to operate its voice-related features, including real-time translation and
          interpretation.
        </p>
        <p>
          When you provide audio recordings through our Services, our proprietary technology analyzes speech
          characteristics to render translated audio that naturally reflects your voice.
        </p>
        <p>
          This processing is limited to providing and improving the accuracy of translation outputs and does not extend
          to any unrelated use, profiling, or independent voice modeling.
        </p>
        <p>We never use your voice data to infer personal traits or behaviors.</p>

        <p class="accent">(c) Personal Data and AI Model Development</p>
        <p>
          SconAI does not use user voice data, conversation content, or any associated Personal Data for AI model
          training, research, or system learning.
        </p>
        <p>
          All processing of such data is strictly confined to service delivery—specifically, real-time translation and
          performance optimization within your active sessions.
        </p>
        <p>We do not use any Personal Data or publicly available data to profile, analyze, or target users.</p>

        <p class="accent">(d) Content Moderation and User Access</p>
        <p>
          While SconAI does not routinely review all user content, we may moderate data inputs (including text and
          audio) and outputs when necessary to ensure platform integrity, prevent abuse, or comply with legal
          requirements.
        </p>
        <p>
          In limited cases, we may share certain content containing Personal Data with trusted partners or service
          providers who assist in maintaining safety and compliance standards.
        </p>
        <p>
          Users who violate our Prohibited Use Policy or applicable laws may have their access to the Services
          temporarily suspended or permanently terminated.
        </p>
      </div>

      <!-- Section 4 -->
      <h4 class="accent section-title">4. Data Recipients</h4>
      <div class="wrapper-paragraph">
        <p>Your Personal Data may be shared in the following limited circumstances:</p>

        <p class="accent">Affiliates.</p>
        <p>
          We may share Personal Data with our current or future affiliates within the SconAI group of companies when
          necessary to support the purposes outlined in this Privacy Policy.
        </p>

        <p class="accent">Vendors and Service Providers.</p>
        <p>
          We may share your Personal Data with trusted third-party vendors and service providers who assist us in
          operating and improving our Services.
        </p>
        <p>
          These partners may provide services such as data hosting, infrastructure management, identity verification,
          content moderation, analytics, technical support, customer service, payment processing, and email delivery.
        </p>

        <p class="accent">Other Users.</p>
        <p>
          In certain cases, your Personal Data may be visible to or shared with other users only when you choose to
          do so—such as during a shared interpretation or translation session that you create or authorize.
        </p>
        <p>
          In such cases, data is visible only to participants you have expressly permitted to join the same session.
        </p>

        <p class="accent">Third Parties.</p>
        <p>
          We may collaborate with third-party partners to provide, maintain, or enhance specific features or services.
        </p>
        <p>
          This may involve granting limited access to Personal Data for technical integration, service improvement, or
          promotional activities, but only where such sharing is necessary and subject to appropriate safeguards.
        </p>
        <p>
          If you share files, translated content, or other Output with external applications, please ensure you trust
          those third parties before sharing.
        </p>

        <p class="accent">As Required by Law or Legal Process.</p>
        <p>
          We may access, preserve, or disclose your Personal Data when required to comply with applicable law, court
          orders, subpoenas, or lawful requests from public authorities.
        </p>
        <p>
          We may also share information where necessary to protect your rights, our rights, or the safety of others,
          or to prevent, detect, or respond to misuse of the Services.
        </p>

        <p class="accent">Corporate Transactions.</p>
        <p>
          In the event of a merger, acquisition, restructuring, or sale of all or part of our business or assets, your
          Personal Data may be transferred to relevant parties such as advisors, counterparties, or acquiring entities,
          subject to appropriate confidentiality protections.
        </p>

        <p class="accent">With Your Consent.</p>
        <p>
          We may share your Personal Data with third parties if you explicitly authorize us to do so—for example, when
          you request a referral to a partner service provider or participate in an event jointly organized with another
          company.
        </p>
        <p>In such cases, we will explain the purpose of the disclosure before obtaining your consent.</p>
      </div>

      <!-- Section 5 -->
      <h4 class="accent section-title">5. International Data Transfers</h4>
      <div class="wrapper-paragraph">
        <p>
          We store and process Personal Data using secure hosting environments located in the Republic of Korea and the
          United States.
        </p>
        <p>
          Depending on your country of residence or where you access the Services, your information may be transferred
          to and processed in a different country.
        </p>
        <p>
          Regardless of where processing occurs, all Personal Data is protected under SconAI's unified data protection
          and security standards.
        </p>
        <p>
          Your Personal Data is transferred and retained only for as long as necessary to fulfill the purposes outlined
          in this Privacy Policy.
        </p>
        <p>
          In certain cases, it may be shared with verified third-party service providers or other SconAI affiliates to
          support the operation, maintenance, and improvement of our Services.
        </p>
        <p>
          In such circumstances, SconAI remains the data controller, while our partners act as data processors or
          joint controllers, depending on the specific processing activity.
        </p>
        <p>We may transfer Personal Data to the following categories of recipients:</p>
        <p class="small">
          · Cloud infrastructure and storage providers located in Korea or the United States, which securely host and
          manage our systems and data;
        </p>
        <p class="small">
          · Technical and operational partners that support the delivery and enhancement of our Services; and
        </p>
        <p class="small">
          · Affiliated entities and subsidiaries of SconAI, as required for service provision, analytics, or
          compliance purposes.
        </p>
        <p>
          Depending on your country of residence, SconAI applies appropriate safeguards when transferring your
          Personal Data outside your jurisdiction. These safeguards may include, as applicable:
        </p>
        <p class="small">
          · Transferring Personal Data only to countries that are recognized by the relevant authorities as providing
          an adequate level of data protection;
        </p>
        <p class="small">
          · Using contractual mechanisms required under applicable laws, such as standard contractual clauses or
          agreements that include protections equivalent to those mandated by your local data protection regulations;
        </p>
        <p class="small">
          · Obtaining your explicit consent before transferring your Personal Data to other jurisdictions when required
          by law.
        </p>
        <p>
          If you would like more information about how we manage cross-border data transfers, or—where applicable—wish
          to obtain a copy of the contractual safeguards we rely on, you may contact us using the details provided in
          the "Contact Us" section below.
        </p>
        <p>
          Please note that the data protection and privacy laws of the jurisdictions where your information is
          processed may differ from those in your region. While your data is handled in another country, it may be
          subject to lawful access by courts, regulatory authorities, or law enforcement agencies in that jurisdiction.
        </p>
      </div>

      <!-- Section 6 -->
      <h4 class="accent section-title">6. Data Retention</h4>
      <div class="wrapper-paragraph">
        <p>
          SconAI retains your Personal Data only for as long as necessary to fulfill the purposes for which it was
          collected, unless a longer retention period is required or permitted by law.
        </p>
        <p>
          Once the data is no longer needed, we take appropriate steps to delete it or to store it in a form that no
          longer allows identification of the individual.
        </p>
        <p>
          When determining how long to retain data, we consider factors such as the type of Services provided, the
          nature and duration of our relationship with you, applicable legal requirements, and statutory limitation
          periods for potential claims.
        </p>
        <p>
          Voice-related data processed through SconChat is not stored beyond three years from your last interaction
          with our Services, unless a longer period is required by law or necessary for compliance or dispute
          resolution purposes.
        </p>
      </div>

      <!-- Section 7 -->
      <h4 class="accent section-title">7. Your Cookie Choices</h4>
      <div class="wrapper-paragraph">
        <p>
          Cookies, pixel tags, SDKs, and similar technologies are used to collect information about how users interact
          with our Services.
        </p>
        <p>
          SconAI and our trusted third-party partners—such as analytics and advertising providers—may use these
          technologies to understand usage patterns, improve performance, and deliver a more relevant experience.
        </p>
        <p>
          Information collected through Cookies may include unique identifiers, system and device information, IP
          address, browser type, operating system, the pages visited before or after using the Services, and
          interaction details such as click behavior, time spent, and access timestamps.
        </p>
        <p>For more detail on what information may be collected automatically, see Section 2(b) of this Policy.</p>

        <p class="accent">Types of Cookies</p>
        <p>
          Session Cookies expire when you close your browser, while Persistent Cookies remain stored for future visits.
        </p>
        <p>The Cookies we or our third-party partners use generally serve the following purposes:</p>

        <p class="accent">Strictly Necessary Cookies.</p>
        <p>
          These are essential for the basic operation of our Services—for example, to enable login functions or protect
          the site from automated access attempts. Because they are required for functionality and security, they
          cannot be disabled.
        </p>

        <p class="accent">Performance & Analytics Cookies.</p>
        <p>
          Used to analyze and measure how our Services are used, helping us maintain, operate, and improve them.
        </p>
        <p>
          We may use our own analytics tools or work with providers such as Google Analytics to better understand
          engagement trends.
        </p>

        <p class="accent">Targeting & Marketing Cookies.</p>
        <p>
          These may be set by us or our advertising partners to display relevant promotions or information—both on
          SconAI websites and across external platforms.
        </p>
        <p>
          They help ensure that advertising content is more aligned with your interests and that repetitive ads are
          reduced.
        </p>

        <p class="accent">Managing Your Cookie Preferences</p>
        <p>
          Depending on your location, we may request your consent before using non-essential Cookies. You can manage
          your preferences through the following options:
        </p>

        <p class="accent">Browser Settings.</p>
        <p>
          Most browsers allow you to control or delete Cookies. You can choose to refuse Cookies or delete existing
          ones, though blocking all Cookies may impact certain Service features.
        </p>

        <p class="accent">Google Analytics Opt-Out.</p>
        <p>
          To prevent Google Analytics from using data collected through Cookies, you can install the browser add-on
          available at https://tools.google.com/dlpage/gaoptout
        </p>

        <p class="accent">Third-Party Advertising Opt-Out.</p>
        <p>
          Some of our partners participate in the Network Advertising Initiative (NAI) or the Digital Advertising
          Alliance (DAA). You can opt out of personalized ads from participating companies via their respective
          websites, or use your mobile device's privacy settings or the AppChoices mobile app to manage ad
          preferences.
        </p>

        <p class="accent">Universal Opt-Out Signals.</p>
        <p>
          If you use a browser or device setting that communicates a universal opt-out preference signal (such as
          Global Privacy Control/GPC), SconAI will honor that signal as a request to disable targeting and marketing
          Cookies.
        </p>
      </div>

      <!-- Section 9 -->
      <h4 class="accent section-title">9. Third Parties</h4>
      <div class="wrapper-paragraph">
        <p>
          Our Services may include links to websites, products, or services operated by third parties that are
          independent of SconAI.
        </p>
        <p>We are not responsible for the content, privacy policies, or practices of such third parties.</p>
        <p>Please note that this Privacy Policy applies only to data collected and processed by SconAI.</p>
        <p>
          Before sharing any information with external websites or services, we encourage you to review their
          respective privacy policies.
        </p>
      </div>

      <!-- Section 10 -->
      <h4 class="accent section-title">10. Security</h4>
      <div class="wrapper-paragraph">
        <p>
          SconAI implements appropriate technical and organizational measures to protect your Personal Data against
          unauthorized access, disclosure, alteration, or destruction.
        </p>
        <p>
          While we continually improve our security infrastructure, no method of electronic transmission or storage is
          completely secure.
        </p>
        <p>
          Therefore, we cannot guarantee absolute protection of your data, to the extent permitted by applicable law.
        </p>
      </div>

      <!-- Section 11 -->
      <h4 class="accent section-title">11. Children's Privacy</h4>
      <div class="wrapper-paragraph">
        <p>
          Our Services are not intended for individuals under the age of 18, and SconAI does not knowingly collect,
          store, or process Personal Data from minors.
        </p>
        <p>If you are under 18, you must not submit any Personal Data through our Services.</p>
        <p>If we learn that we have inadvertently collected such data, we will delete it promptly.</p>
        <p>
          In addition, users are strictly prohibited from uploading, transmitting, or otherwise providing Voice Data
          of individuals under 18 through any of our Services.
        </p>
        <p>
          If you believe such data may have been submitted or processed in error, please contact us at
          connect@sconai.com.
        </p>
      </div>

      <!-- Section 12 -->
      <h4 class="accent section-title">12. Additional Information About Biometric Data</h4>
      <div class="wrapper-paragraph">
        <p>
          Certain SconChat features may process limited biometric information—specifically voice characteristics—solely
          for the purpose of distinguishing speakers during interpretation or translation sessions.
        </p>
        <p>
          This data is not used for identity verification, profiling, or any purpose unrelated to real-time speaker
          differentiation.
        </p>
        <p>
          When necessary, these voice characteristics may be shared with authorized service providers that support the
          operation and accuracy of SconChat's speaker-differentiation features. Such providers are contractually
          restricted from using the data for any other purpose.
        </p>
        <p>
          Users may delete their stored voice characteristics at any time directly within the Service settings, and
          all biometric-related data associated with your account will be permanently deleted upon account termination.
        </p>
        <p>
          SconAI retains biometric data only as long as you choose to keep it active for speaker-differentiation
          purposes, and automatically removes it when deleted by the user or when your account is closed.
        </p>
      </div>

      <!-- Section 13 -->
      <h4 class="accent section-title">13. Updates to this Policy</h4>
      <div class="wrapper-paragraph">
        <p>
          This Privacy Policy may be updated periodically to reflect changes in our practices or legal requirements.
        </p>
        <p>
          If any significant modifications are made, we will notify users as required by applicable law.
        </p>
      </div>

      <!-- Section 14 -->
      <h4 class="accent section-title">14. Contact Us</h4>
      <div class="wrapper-paragraph">
        <p>
          For questions or concerns regarding this Policy or the processing of your Personal Data, please contact our
          Data Protection Officer at connect@sconai.com, or by mail at:
        </p>
        <p class="small">Data Protection Officer</p>
        <p class="small">SconAI Inc.</p>
        <p class="small">1111B S Governors Ave STE 40902</p>
        <p class="small">Dover, DE 19904</p>
        <p class="small">United States</p>
        <p>
          You may also exercise your rights under applicable data protection laws by submitting a request through our
          online form.
        </p>
        <p>
          Please indicate the specific right you wish to exercise (e.g., "Withdraw my consent") and include your place
          of residence (state, province, or country).
        </p>
        <p>Before we process your request, you may be asked to provide additional information to verify your identity.</p>
        <p>Please note that certain rights may be subject to legal exceptions or limitations.</p>
      </div>
    </template>
  </body>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();
const isKorean = computed(() => locale.value === 'ko');
</script>

<style lang="scss" scoped>
.title {
  font-weight: bold;
  margin-top: 1rem;
  margin-bottom: 1.5rem;
}

.section-title {
  margin: 1.5rem 0 0.5rem 0;
}

.wrapper-paragraph {
  margin: 0 0 1rem 1.5rem;

  .small {
    margin: 0 0 0 1.5rem;
  }
}
</style>
